<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    width="600px"
  >
    <div class="remark__content">
      <el-row>
        <!-- <el-col :span="6">SIM卡号：</el-col>
        <el-col :span="18">
          <el-input size="small" v-model="formData.simCard" :disabled="disabled" />
        </el-col> -->
        <el-col :span="6">iccid号：</el-col>
        <el-col :span="18">
          <el-input size="small" v-model="formData.iccid" :disabled="disabled" />
        </el-col>
        <el-col :span="6">SN号：</el-col>
        <el-col :span="18">
          <el-input size="small" v-model="formData.sn" :disabled="disabled" />
        </el-col>
        <!-- <el-col :span="6">IMEI号：</el-col>
        <el-col :span="18">
          <el-input size="small" v-model="formData.imei" :disabled="disabled" />
        </el-col> -->
  
        <el-col :span="6">设备型号：</el-col>
        <el-col :span="18">
          <el-input size="small" v-model="formData.deviceType" :disabled="disabled" />
        </el-col>
        <el-col :span="6">续费一年价格：</el-col>
        <el-col :span="18">
          <el-input-number size="small" v-model="formData.oneYearPrice" :precision="2" :step="1" />
        </el-col>
        <el-col :span="6">续费两年价格：</el-col>
        <el-col :span="18">
          <el-input-number size="small" v-model="formData.twoYearPrice" :precision="2" :step="1" />
        </el-col>
        <!-- <el-col :span="6">续费三年价格：</el-col>
        <el-col :span="18">
          <el-input-number size="small" v-model="formData.threeYearPrice" :precision="2" :step="1" />
        </el-col> -->
        <el-col :span="6">备注</el-col>
        <el-col :span="18">
          <el-input size="small" v-model="formData.remark" :rows="3" type="textarea" />
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="type" @click="$emit('update:visible')">取 消</el-button>
      <el-button size="type" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name:"RenewalPriceForm",
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    info:{
      type:Object,
      default:() => {}
    }
  },
  data(){
    return {
      formData:{
        /**SIM卡号 */
        simCard:'',
        /**iccid */
        iccid:'',
        /**设备类型 */
        deviceType:'',
        /**续费一年价格 */
        oneYearPrice:'',
        /**续费两年价格 */
        twoYearPrice:'',
        /**续费三年价格 */
        threeYearPrice:'',
        /**sn */
        sn:'',
        /**imei */
        imei:'',
        /**备注 */
        remark:'',
      }
    }
  },
  computed:{
    show:{
      get(){
        return this.visible
      },
      set(val){
        this.$emit('update:visible',val);
      }
    },
    title(){
      return this.info ? '修改续费价格' : '新增续费价格';
    },
    disabled(){
      return this.info ? true : false;
    }
  },
  watch:{
    visible:{
      handler(val){
        if(val){
          this.init();
        }
      }
    },
  },
  methods:{
    init(){
      if(this.info){
        this.formData = { ...this.info };
      }else{
        this.formData = {
          /**SIM卡号 */
          simCard:'',
          /**iccid */
          iccid:'',
          /**设备类型 */
          deviceType:'',
          /**续费一年价格 */
          oneYearPrice:'',
          /**续费两年价格 */
          twoYearPrice:'',
          /**续费三年价格 */
          threeYearPrice:'',
          /**sn */
          sn:'',
          /**imei */
          imei:'',
          /**备注 */
          remark:'',
        }
      }
      console.log(this.formData,'this.formData')
    },
    // 备注
    async onConfirm(){
      try{
        const { 
          simCard,
          iccid,
          deviceType,
          oneYearPrice,
          twoYearPrice,
          threeYearPrice,
          sn,
          imei
         } = this.formData;
        // if(!simCard) throw { msg:'请填写SIM卡号' };
        if(!iccid) throw { msg:'请填写iccid号' };
        if(!sn) throw { msg:'请填写sn号' };
        // if(!imei) throw { msg:'请填写imei号' };
        if(!deviceType) throw { msg:'请填写设备类型' };
        if(!oneYearPrice) throw { msg:'请填写续费一年价格' };
        if(!twoYearPrice) throw { msg:'请填写续费两年价格' };
        // if(!threeYearPrice) throw { msg:'请填写续费三年价格' };
        const url = this.info ? 'updateExternalSimRenewPrice' : 'addExternalSimRenewPrice';
        const res = await this.$API[url](this.formData);
        if(res.data.code !== 0) throw { msg:res.data.msg };
        this.$message({
          type:'success',
          message:'成功'
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$message({
          type:'warning',
          message:msg
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.remark__content{
  ::v-deep .el-col{
    margin-bottom: 10px;
    line-height: 34px;
    text-align: right;
    .el-input-number{
      width: 100%;
    }
  }
}
</style>
